import { Quote } from "../../api/Quote/Quote";
import { FeatureDiscount } from "../../app/consts";
import { useConfig } from "../config/ConfigContext";
import { DeductionLine } from "./DeductionLine";

interface Props {
  quote: Quote;
  onDelete: (quoteDeductionId: string) => void;
}

export const DeductionLines = ({ quote, onDelete }: Props) => {
  const { isFeatureEnabled } = useConfig();

  if (!isFeatureEnabled(FeatureDiscount)) {
    return <></>;
  }

  return (
    <>
      {quote.deductions.map((item, i) => (
        <DeductionLine key={i} deduction={item} onDelete={onDelete} />
      ))}
    </>
  );
};
